
export const data = [
    { filename: "eyecup.png", price: 50, title: "eyecup", x: -35, z: -28 },
    { filename: "face.png", price: 50, title: "face", x: -18, z: -28 },
    { filename: "molly.png", price: 50, title: "molly", x: -20, z: -5 },
    { filename: "ben.png", price: 50, title: "ben", x: 0, z: -40 },
    { filename: "tashi.png", price: 50, title: "tashi", x: 0, z: -22 },
    { filename: "shell.png", price: 50, title: "shell", x: -3, z: -10 },
    { filename: "conch.png", price: 50, title: "conch", x: -3, z: 2 },
    { filename: "apple.png", price: 50, title: "apple", x: 8, z: 6 },
    { filename: "halvard.png", price: 50, title: "halvard", x: -3, z: 22 },
    { filename: "closed_eyes.png", price: 50, title: "closed eyes", x: -25, z: 10 },
    { filename: "meatball.png", price: 50, title: "meatball", x: -18, z: 30 },
]
